import Vue from 'vue'
import { redmine } from 'src/app-config'

const url = api => redmine.domain + '/smeeredmine' + api

const adminRequestOptions = {
  headers: {
    'X-Redmine-API-Key': redmine.adminApiKey
  }
}

const userRequestOptions = {
  headers: {
    'X-Redmine-API-Key': null
  }
}

const errorMessage = (response, defaultMessage) => {
  return response.body.error || response.body.errors.join(', ') || defaultMessage + ' Reason: ' + response.statusText
}

export const updateUserApiKey = apiKey => { userRequestOptions.headers['X-Redmine-API-Key'] = apiKey }

const updateIssueOneByOne = function ({ issues, idx, oneDone, allDone, onFailed }) {
  if (idx === undefined) {
    idx = 0
  }
  if (idx < issues.length) {
    let issue = issues[idx]
    Vue.http.put(url('/issues/' + issue.id + '.json'), {
      issue: {...issue.data}
    }, userRequestOptions).then(() => {
      oneDone(issue)
    }).catch(() => {
      onFailed(issue)
    }).then(() => {
      idx++
      updateIssueOneByOne({ issues, idx, oneDone, allDone, onFailed })
    })
  } else {
    allDone()
  }
}

export const registerUser = params => {
  return new Promise((resolve, reject) => {
    Vue.http.post(url('/users.json'), params, adminRequestOptions).then(response => {
      resolve(response.body.user)
    }).catch(response => {
      reject({ message: errorMessage(response, '(Redmine) Failed to register user.') })
    })
  })
}

export const getRoles = () => {
  return new Promise((resolve, reject) => {
    Vue.http.get(url('/roles.json'), adminRequestOptions).then(response => {
      let roles = response.body.roles
      resolve(roles)
    }).catch(response => {
      reject({ message: errorMessage(response, '(Redmine) Failed to get roles.') })
    })
  })
}

export const getUsers = () => {
  return new Promise((resolve, reject) => {
    Vue.http.get(url('/users.json'), adminRequestOptions).then(response => {
      resolve(response.body.users)
    }).catch(response => {
      reject({ message: errorMessage(response, '(Redmine) Failed to retrieve all users.') })
    })
  })
}

export const getUserByLoginId = loginId => {
  return new Promise((resolve, reject) => {
    let options = {
      ...adminRequestOptions,
      params: {
        name: loginId
      }
    }
    Vue.http.get(url('/users.json'), options).then(response => {
      let user = response.body.users.find(user => user.login === loginId)
      if (user) {
        resolve(user)
      } else {
        reject({ message: 'User not found' })
      }
    }).catch(response => {
      reject({ message: errorMessage(response, '(Redmine) Failed to get user by login ID.') })
    })
  })
}

export const getUserDetail = userId => {
  return new Promise((resolve, reject) => {
    let options = {
      ...adminRequestOptions,
      params: {
        include: 'memberships'
      }
    }
    Vue.http.get(url('/users/' + userId + '.json'), options).then(response => {
      let user = response.body.user
      if (user) {
        resolve(user)
      } else {
        reject({ message: 'User not found' })
      }
    }).catch(response => {
      reject({ message: errorMessage(response, '(Redmine) Failed to get user with memberships.') })
    })
  })
}

export const getProjects = () => {
  return new Promise((resolve, reject) => {
    Vue.http.get(url('/projects.json'), adminRequestOptions).then(response => {
      resolve(response.body.projects)
    }).catch(response => {
      reject({ message: errorMessage(response, 'Failed to get projects.') })
    })
  })
}

export const registerMembership = ({ project, redmineUser, role }) => {
  return new Promise((resolve, reject) => {
    Vue.http.post(url('/projects/' + project.id + '/memberships.json'), {
      membership: {
        'user_id': redmineUser.id,
        'role_ids': [role.id]
      }
    }, adminRequestOptions).then(response => {
      resolve(response.body.membership)
    }).catch(response => {
      reject({ message: errorMessage(response, '(Redmine) Failed to register membership.') })
    })
  })
}

export const getCustomFields = () => {
  return new Promise((resolve, reject) => {
    Vue.http.get(url('/custom_fields.json'), adminRequestOptions).then(response => {
      resolve(response.body['custom_fields'])
    }).catch(response => {
      reject({ message: errorMessage(response, '(Redmine) Failed to get custom fileds.') })
    })
  })
}

export const getTrackers = () => {
  return new Promise((resolve, reject) => {
    Vue.http.get(url('/trackers.json'), adminRequestOptions).then(response => {
      resolve(response.body.trackers)
    }).catch(response => {
      reject({ message: errorMessage(response, '(Redmine) Failed to get trackers.') })
    })
  })
}



// WEBPACK FOOTER //
// ./src/services/redmine.js